import { IconType } from '../enum/icon-type.enum';

export const GetIconType = (type?: IconType): string => {
    switch (type) {
        case IconType.CARD:
            return 'assets/img/card.svg';
        case IconType.EMAIL:
            return 'assets/img/correo.svg';
        case IconType.LISTO:
            return 'assets/img/listo.svg';
        case IconType.INFO:
            return 'assets/img/info.svg';
        case IconType.SCHEDULE:
            return 'assets/img/horario.svg';
        case IconType.DELETE:
            return 'assets/img/eliminar.svg'
        case IconType.ERROR:
        default:
            return 'assets/img/error.svg';
    }
};
